import { render, staticRenderFns } from "./MenuItemAbs.vue?vue&type=template&id=01968499&scoped=true&"
import script from "./MenuItemAbs.vue?vue&type=script&lang=js&"
export * from "./MenuItemAbs.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemAbs.vue?vue&type=style&index=0&id=01968499&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01968499",
  null
  
)

export default component.exports